/* eslint-disable id-match */
export const WIDGET_MENU_ID = 'te__acsWidgetMenu';
export const WIDGET_BUTTON_ID = 'te__acsWidgetBtn';
export const WIDGET_TOOLTIP_ID = 'te__acsWidgetTooltip';
export const TOOLTIP_MSG_ID = 'te__acsTooltipMsg';
export const STYLESHEET_ID = 'te__acsStylesheet';
export const WIDGET_MENU_CLASS = 'te__acs-widget-iframe';
export const WIDGET_BUTTON_CLASS = 'te__acs-widget-button';
export const WIDGET_TOOLTIP_CLASS = 'te__acs-widget-tooltip';
export const TOOLTIP_MSG_CLASS = 'te__acs-tooltip-message';

export const jobChatState = {
	isInitialized: false,
};

const offset = 50;
const availableHeight = window.innerHeight - offset;

export const widgetStyle = `
#${WIDGET_MENU_ID}.${WIDGET_MENU_CLASS} {
	position: fixed;
	z-index: 3999999;
	height: 630px;
	max-height: ${availableHeight}px;
	width: 400px;
	bottom: 20px;
	right: 20px;
	border-radius: 18px;
	box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12),
		0 4px 5px 0 rgba(0, 0, 0, 0.14);
	background-color: transparent;
	margin: 0;
	padding: 0;
	border: none;
	outline: none;
	box-sizing: border-box;
	user-select: none;
	display: none;
	opacity: 0;
	transform: translate3d(0, 15px, 0);
	transition: 0.2s opacity, 0.2s transform;
}
#${WIDGET_MENU_ID}.${WIDGET_MENU_CLASS}.left {
	left: 20px;
	right: auto;
}
@media (max-width: 420px) {
	#${WIDGET_MENU_ID}.${WIDGET_MENU_CLASS} {
		width: 100%;
		height: 100%;
		top: 0;
		right: auto;
		left: auto;
	}
}
`
	// TODO: should minify css but it's currently NBD -Amir
	.trim();
